import React from 'react';

import { Children } from 'interfaces';

import {
  Wrapper
} from './SidebarBox.styles';

export interface SidebarBoxProps {
  children: Children;
  className?: string;
}

const SidebarBox = ({ children, className }: SidebarBoxProps) => {
  return (
    <Wrapper className={className}>
      {children}
    </Wrapper>
  );
};

export default SidebarBox;
